<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>首页</el-breadcrumb-item>
      <el-breadcrumb-item>赛务管理</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/raceManagement/team_management/team_race_management' }">团体赛赛务管理 </el-breadcrumb-item>
      <el-breadcrumb-item>战队进场管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">信息筛选</span>
        </el-col>
      </el-row>
      <el-form
          :model="queryForm"
          class="filter_Form"
          label-width="90px"
          ref="queryFormRef"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item label="赛季" prop="season">
                <el-select
                    placeholder="请选择类型"
                    style="width: 100%"
                    v-model="queryForm.season"
                >
                    <el-option
                        v-for="item in dict_season"
                        :key="item.dictCode"
                        :label="item.dictLabel"
                        :value="item.dictValue"
                    ></el-option>
                </el-select> </el-form-item
        ></el-col>
        <el-col :span="8">
            <el-form-item label="赛程" prop="raceSchedule">
                <el-select
                    placeholder="请选择"
                    style="width: 100%"
                    v-model="queryForm.raceSchedule"
                    clearable
                >
                    <el-option
                        v-for="item in raceScheduleList"
                        :key="item.id"
                        :label="item.scheduleName"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
        </el-col>
          <el-col :span="8">
            <el-form-item label="组别" prop="level">
              <el-select
                  placeholder="请选择"
                  v-model="queryForm.level"
                  style="width: 100%;"
                  @change="levelChange"
              >
                  <el-option
                      v-for="(item, i) in levels"
                      :key="i"
                      :label="item"
                      :value="i"
                  ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="比赛状态" prop="matchStatus">
              <el-select
                  placeholder="请选择"
                  v-model="queryForm.matchStatus"
                  style="width: 100%;"
                  clearable
                  @change="search"
              >
                  <el-option
                      v-for="(item, i) in statusList"
                      :key="i"
                      :label="item"
                      :value="i"
                  ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="战队名称" prop="teamName">
              <el-input v-model="queryForm.teamName" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-button type="primary" style="margin-left: 20px;" @click="search">查询</el-button>
            <el-button type="primary" plain @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">对战信息(15s刷新/点击[查询]刷新)</span>
        </el-col>
      </el-row>
      <!-- 考场 Tab 切换 -->
      <el-tabs
        v-model="activeRoomTab"
        type="card"
        class="room-tabs"
        @tab-click="onRoomTabChange"
        style="margin-top: 10px;"
      >
        <el-tab-pane label="全部考场" name="all" />
        <el-tab-pane
          v-for="(room, i) in rooms"
          :key="i"
          :label="room"
          :name="room"
        />
      </el-tabs>
      <div class="booth" v-if="tabName !== 'all' && boothInfo">
        <div class="booth-title" @click="showMembers = !showMembers">裁判席成员<span>(点击{{ showMembers ? '收起' : '展开' }})</span></div>
        <div class="booth-members" v-if="showMembers">
          <div class="booth-member">
            <div class="booth-role">总控</div>
            <el-image class="booth-avatar" :src="boothInfo.directorUrl" :preview-src-list="[boothInfo.directorUrl]" fit="contain">
               <template #error>
                  <div class="image-slot">
                    未上传
                  </div>
                </template>
            </el-image>
            <div class="booth-name">{{ boothInfo.director }}</div>
          </div>
          <div class="booth-member">
            <div class="booth-role">中方</div>
            <el-image class="booth-avatar" :src="boothInfo.judgeUrl" :preview-src-list="[boothInfo.judgeUrl]" fit="contain">
              <template #error>
                  <div class="image-slot">
                    未上传
                  </div>
                </template>
            </el-image>
            <div class="booth-name">{{ boothInfo.judge }}</div>
          </div>
          <div class="booth-member">
            <div class="booth-role">发音官</div>
            <el-image class="booth-avatar" :src="boothInfo.pronouncerUrl" :preview-src-list="[boothInfo.pronouncerUrl]" fit="contain">
              <template #error>
                  <div class="image-slot">
                    未上传
                  </div>
                </template>
            </el-image>
            <div class="booth-name">{{ boothInfo.pronouncer }}</div>
          </div>
          <div class="booth-member">
            <div class="booth-role">计时员</div>
            <el-image class="booth-avatar" :src="boothInfo.recorderUrl" :preview-src-list="[boothInfo.recorderUrl]" fit="contain">
              <template #error>
                  <div class="image-slot">
                    未上传
                  </div>
                </template>
            </el-image>
            <div class="booth-name">{{ boothInfo.recorder }}</div>
          </div>
        </div>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%"
        header-cell-class-name="tableHeaderStyle"
        :row-class-name="tableRowClassName"
        row-key="id"
        :expand-row-keys="expandedRows"
        @expand-change="expandChange">
        <el-table-column type="expand">
          <template slot-scope="props">
            <div class="flex">
              <div class="card" v-if="school1.teacher">
                <div class="team-title">
                  <span>第一战队 <el-tag :type="currentItem.school1Sign ? 'success' : 'warning'" size="mini">{{ currentItem.school1Sign ? '已签到' : '未签到' }}</el-tag></span>
                  <el-button :type="currentItem.school1Sign ? 'danger' : 'primary'" size="small" @click="signInFn(1)">{{ currentItem.school1Sign ? '取消签到' : '候场签到'}}</el-button>
                </div>
                <div class="title vs1">【{{ props.row.school1name }}】{{ props.row.s1name }}</div>
                <div class="flex2">
                  <div>
                    <div class="title t1">领队老师</div>
                    <div class="box">
                      <div class="user teacher">
                        <div class="ava">
                          <el-image :src="school1.teacher.oneInchPhoto" :preview-src-list="[school1.teacher.oneInchPhoto]"></el-image>
                        </div>
                        <div class="right">
                          <div class="name">{{ school1.teacher.name }}<span v-if="school1.teacher.enName">-{{ school1.teacher.enName }}</span></div>
                          <div class="phone">{{ school1.teacher.phone }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="school1.accompanyTeacher">
                    <div class="title t1">陪同老师</div>
                    <div class="box">
                      <div class="user teacher">
                        <div class="ava">
                          <el-image :src="school1.accompanyTeacher.oneInchPhoto" :preview-src-list="[school1.accompanyTeacher.oneInchPhoto]"></el-image>
                        </div>
                        <div class="right">
                          <div class="name">{{ school1.accompanyTeacher.name }}<span v-if="school1.accompanyTeacher.enName">-{{ school1.accompanyTeacher.enName }}</span></div>
                          <div class="phone">{{ school1.accompanyTeacher.phone }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="title t1">战队成员</div>
                <div class="box">
                  <div class="user" v-for="(user, n) in school1.list" :key="n">
                    <div class="ava">
                      <el-image :src="user.oneInchPhoto" :preview-src-list="[user.oneInchPhoto]"></el-image>
                    </div>
                    <div class="right">
                      <div class="name"><span v-if="user.number">【{{ user.number }}】</span>{{ user.name }}<span v-if="user.enName">-{{ user.enName }}</span></div>
                      <div class="name grade">{{ formatGrade(user.grade) }}</div>
                      <div class="phone">{{ user.phone }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card" v-if="school2.teacher">
                <div class="team-title">
                  <span>第二战队 <el-tag :type="currentItem.school2Sign ? 'success' : 'warning'" size="mini">{{ currentItem.school2Sign ? '已签到' : '未签到' }}</el-tag></span>
                  <el-button :type="currentItem.school2Sign ? 'danger' : 'primary'" size="small" @click="signInFn(2)">{{ currentItem.school2Sign ? '取消签到' : '候场签到'}}</el-button>
                </div>
                <div class="title vs2">【{{ props.row.school2name }}】{{ props.row.s2name }}</div>
                <div class="flex2">
                  <div>
                    <div class="title t1">领队老师</div>
                    <div class="box">
                      <div class="user teacher">
                        <div class="ava">
                          <el-image :src="school2.teacher.oneInchPhoto" :preview-src-list="[school2.teacher.oneInchPhoto]"></el-image>
                        </div>
                        <div class="right">
                          <div class="name">{{ school2.teacher.name }}<span v-if="school2.teacher.enName">-{{ school2.teacher.enName }}</span></div>
                          <div class="phone">{{ school2.teacher.phone }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="school2.accompanyTeacher">
                    <div class="title t1">陪同老师</div>
                    <div class="box">
                      <div class="user teacher">
                        <div class="ava">
                          <el-image :src="school2.accompanyTeacher.oneInchPhoto" :preview-src-list="[school2.accompanyTeacher.oneInchPhoto]"></el-image>
                        </div>
                        <div class="right">
                          <div class="name">{{ school2.accompanyTeacher.name }}<span v-if="school2.accompanyTeacher.enName">-{{ school2.accompanyTeacher.enName }}</span></div>
                          <div class="phone">{{ school2.accompanyTeacher.phone }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="title t1">战队成员</div>
                <div class="box">
                  <div class="user" v-for="(user, n) in school2.list" :key="n">
                    <div class="ava">
                      <el-image :src="user.oneInchPhoto" :preview-src-list="[user.oneInchPhoto]"></el-image>
                    </div>
                    <div class="right">
                      <div class="name"><span v-if="user.number">【{{ user.number }}】</span>{{ user.name }}<span v-if="user.enName">-{{ user.enName }}</span></div>
                      <div class="name grade">{{ formatGrade(user.grade) }}</div>
                      <div class="phone">{{ user.phone }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="组别"
          width="60px"
          prop="level" :formatter="levelFormat">
        </el-table-column>
        <el-table-column
          label="第一战队"
          width="180px"
          prop="name">
          <template slot-scope="scoped">
            <div class="vs1 tablevs">学校：{{ scoped.row.s1name }}</div>
            <div class="vs1 tablevs">战队：{{ scoped.row.school1name }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="第二战队"
          width="180px"
          prop="desc">
          <template slot-scope="scoped">
            <div class="vs2 tablevs">学校：{{ scoped.row.s2name }}</div>
            <div class="vs2 tablevs">战队：{{ scoped.row.school2name }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="赛程">
          <template slot-scope="scoped">
            {{ scoped.row.itsoRefereeMatchType ? scoped.row.itsoRefereeMatchType.name : '' }}
          </template>
        </el-table-column>
        <el-table-column
          label="考场"
          prop="roomname">
        </el-table-column>
        <el-table-column
          label="比赛时间"
          width="100px"
          prop="timestr">
          <template slot-scope="scoped">
            <div>{{ dateFormat(scoped.row.timestr) }}</div>
            <div>{{ timeFormat(scoped.row.timestr) }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="场次"
          prop="session">
        </el-table-column>
        <el-table-column
          label="当前游戏"
          width="120px"
          prop="timestr">
          <template slot-scope="scoped">
            <div class="game-state" v-if="scoped.row.rounding">{{ gameNameFormat(scoped.row) }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="进场状态"
          prop="intoRoom">
          <template slot-scope="scoped">
            <el-tag size="mini" :type="scoped.row.intoRoom ? 'success' : 'info'">
              {{ scoped.row.intoRoom ? '已进考场' : '未进考场' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="比赛状态"
          prop="matchStatus">
          <template slot-scope="scoped">
            <el-tag size="mini" :type="scoped.row.matchStatus === 0 ? 'info'
              : scoped.row.matchStatus === 1 ? 'warning'
              : scoped.row.matchStatus === 2 ? 'success'
              : scoped.row.matchStatus === 3 ? 'danger'
              :  'info'">
              {{ statusList[scoped.row.matchStatus] }}
            </el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="操作"
          width="90px">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              :style="{'color': scope.row.intoRoom ? '#F56C6C' : '#409EFF'}"
              @click="confirmEnter(scope.row)"
              >{{ scope.row.intoRoom ? '取消进场' : '确认进场' }}</el-button
            >
          </template>
        </el-table-column> -->
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.pageNum"
        :page-sizes="[10, 20, 40, 80]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dict_season: this.$userInfo.getDataList(this, 't_season', this.$store.state.flag).then(value => { this.dict_season = value }),
      raceScheduleList: [],
      tableData: [],
      levels: [
        '小学组', '初中组', '高中组'
      ],
      statusList: [
        '未开始', '待排兵布阵', '进行中', '已结束'
      ],
      rooms: [],
      activeRoomTab: 'all',
      queryForm: {
        pageNum: 1,
        pageSize: 20,
        level: '',
        roomName: '',
        teamName: '',
        season: this.$chnEngStatusCode.defaultSeason,
        raceSchedule: '18'
      },
      total: 0,
      school1: {},
      school2: {},
      expandedRows: [],
      currentItem: {},
      timer: null,
      tabName: 'all',
      showMembers: true,
      boothInfo: null
    }
  },
  created () {
    this.getRooms()
    this.intervalFn()
    this.getRaceScheduleList()
  },
  beforeDestroy () {
    clearInterval(this.timer)
    this.timer = null
  },
  methods: {
    // 获取赛程
    getRaceScheduleList () {
      this.$chnEngPublicRequest.querySeasonRaceSchedule(this, { activityType: '2' }).then(data => {
        this.raceScheduleList = data
        this.search()
      })
    },
    goBack () {
      this.$router.back()
    },
    search () {
      this.queryForm.pageNum = 1
      this.getList()
    },
    reset () {
      this.queryForm = {
        pageNum: 1,
        pageSize: 20,
        level: '',
        roomName: this.activeRoomTab === 'all' ? '' : this.activeRoomTab,
        teamName: ''
      }
      this.getRooms()
      this.getList()
    },
    handleSizeChange (newSize) {
      this.queryForm.pageSize = newSize
      this.getList()
    },
    handleCurrentChange (newCurPage) {
      this.queryForm.pageNum = newCurPage
      this.getList()
    },
    intervalFn () {
      this.timer = setInterval(() => {
        this.getList()
      }, 15000)
    },
    getList () {
      this.$http.get('/itsoReferee/ipadMatchs', { params: this.queryForm }).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.list
          this.total = res.data.total
        }
      })
    },
    levelChange () {
      this.getRooms()
      this.getList()
    },
    getRooms () {
      this.$http.get('/itsoReferee/matchRoomNames', { params: { level: this.queryForm.level } }).then(res => {
        if (res.code === 200) {
          this.rooms = res.data
          // 如果当前选中的考场在新列表中不存在，自动切回全部考场
          if (this.activeRoomTab !== 'all' && !this.rooms.includes(this.activeRoomTab)) {
            this.activeRoomTab = 'all'
            this.queryForm.roomName = ''
            this.queryForm.pageNum = 1
            this.getList()
          }
        }
      })
    },
    // 考场 Tab 切换
    onRoomTabChange (tab) {
      this.tabName = tab.name
      console.log(this.tabName)
      this.queryForm.pageNum = 1
      this.queryForm.roomName = tab.name === 'all' ? '' : tab.name
      this.getList()
      this.getBooth()
    },
    getBooth () {
      this.$http.get('itsoRefereeBooth/infoByName', { params: { roomName: this.tabName, season: this.queryForm.season, raceSchedule: this.queryForm.raceSchedule } }).then(res => {
        if (res.code === 200) {
          this.boothInfo = res.data
        }
      })
    },
    expandChange (item, expandedRows) {
      if (this.expandedRows.includes(item.id)) {
        // 如果当前行已展开，点击后关闭
        this.expandedRows = []
        this.school1 = {}
        this.school2 = {}
      } else {
        // 展开当前行，关闭其他行
        this.currentItem = item
        // this.expandedRows = [item.id]
        this.getTeamInfo(item.school1id, 1)
        // this.getTeamInfo(item.school2id, 2)
      }
      console.log(this.expandRowKeys)
    },
    getTeamInfo (teamId, type) {
      this.$http.get('/itsoReferee/getAllItsoUsers', { params: { teamId } }).then(res => {
        if (res.code === 200) {
          if (type === 1) {
            this.school1 = res.data
            this.getTeamInfo(this.currentItem.school2id, 2)
          } else if (type === 2) {
            this.school2 = res.data
            this.expandedRows = [this.currentItem.id]
          }
        }
      })
    },
    // 确认进场
    confirmEnter (item) {
      this.$http.post('/itsoReferee/updateMatchIntoRoom', { id: item.id, intoRoom: !item.intoRoom }).then(res => {
        if (res.code === 200) {
          this.getList()
        }
      })
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.intoRoom && row.matchStatus !== 3) {
        return 'success-row'
      } else if (row.matchStatus === 3) {
        return 'gray-row'
      }
      return ''
    },
    levelFormat (data) {
      return this.levels[data.level]
    },
    dateFormat (str) {
      return str.split('-')[0].slice(0, 10)
    },
    timeFormat (time) {
      return time.split('-')[0].slice(11, 16) + '-' + time.split('-')[1].slice(11, 16)
    },
    formatGrade (grade) {
      return this.$userInfo.getGradeData().find(item => item.dictCode === grade).dictLabel
    },
    signInFn (type) {
      const teamSign = type === 1 ? !this.currentItem.school1Sign : !this.currentItem.school2Sign
      this.$http.post('itsoReferee/updateMatchTeamSign', {
        id: this.currentItem.id,
        teamId: type === 1 ? this.currentItem.school1id : this.currentItem.school2id,
        teamSign
      }).then(res => {
        if (res.code === 200) {
          this.$message.success(teamSign ? '已签到' : '已取消签到')
          if (type === 1) {
            this.currentItem.school1Sign = teamSign
          } else if (type === 2) {
            this.currentItem.school2Sign = teamSign
          }
          this.getList()
        }
      })
    },
    gameNameFormat (item) {
      if (item.rounding) {
        const rounding = JSON.parse(item.rounding)
        return `${rounding.index + 1}、${rounding.name}`
      } else {
        return ''
      }
    }
  }
}
</script>

<style scoped lang="less">
.el-table .success-row {
  background: #f0f9eb;
}
/deep/ .el-table .gray-row {
  background: #DADADA;
}
.flex{
  display: flex;
}
.flex2{
  display: flex;
  justify-content: center;
}
.card{
  width: 48%;
  box-sizing: border-box;
  background-color: #efefef;
  padding: 10px 20px;
  margin: 10px;
}
.team-title{
  font-weight: bold;
  margin-top: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.title{
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 10px;
  margin-top: 10px;
  text-align: center;
  padding: 6px 0;
}
.t1{
  color: #4096ff;
}
.box{
  // overflow: hidden;
  display: flex;
  flex-wrap: wrap;
}
.user{
  display: flex;
  align-items: center;
  // float: left;
  // width: 33%;
  flex: 0 0 33.3333%;
  box-sizing: border-box;
  margin-bottom: 10px;
}
.teacher{
  float: none;
  margin: 0 auto 10px;
  width: 280px;
}
.ava{
  width: 60px;
  height: 60px;
  border-radius: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  overflow: hidden;
  img{
    margin-top: 12px;
    width: 60px;
  }
}
.right{
  flex: 1;
  min-width: 0;
}
.name{
  margin-bottom: 4px;
  font-size: 14px;
  color: #000;
}
.grade{
  color: #4096FF;
  font-size: 12px;
}
</style>

<style scoped lang="less">
/* 考场 Tab 选中状态 */
.room-tabs {
  ::v-deep .el-tabs__nav {
    border: none !important;
    padding: 4px 4px 0 4px;
  }
  ::v-deep .el-tabs__header {
    border-bottom: none;
    margin-bottom: 14px;
    overflow: visible;
  }
  ::v-deep .el-tabs__item {
    height: 36px;
    line-height: 36px;
    padding: 0 20px;
    margin-right: 6px;
    border: 1px solid #dcdfe6;
    border-radius: 6px 6px 0 0;
    background: #f5f7fa;
    color: #606266;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.25s ease;
  }
  ::v-deep .el-tabs__item:hover {
    color: #409eff;
    background: #ecf5ff;
    border-color: #b3d8ff;
  }
  ::v-deep .el-tabs__item.is-active {
    background: #409eff;
    color: #ffffff;
    font-weight: 600;
    border-color: #409eff;
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.35);
    transform: scale(1.06);
  }
  ::v-deep .el-tabs__nav-next,
  ::v-deep .el-tabs__nav-prev {
    line-height: 36px;
  }
}
.vs1{
  background-color: #f29d00;
  color: #000;
}
.vs2{
  background-color: #251716;
  color: #fff;
}
.tablevs{
  padding: 0 4px;
}
.game-state{
  font-size: 14px;
  font-weight: bold;
  color: #fff;
  background-color: #67C23A;
  text-align: center;
  border-radius: 6px;
  padding: 4px 0;
}

/* 替换展开图标 */
/deep/ .el-table__expand-icon {
  /* 隐藏原有图标 */
  -webkit-font-smoothing: antialiased;
}

/deep/ .el-table__expand-icon .el-icon-arrow-right:before {
  /* 使用自定义图标，例如使用 Element UI 的其他图标 */
  content: "\e6c5"; /* 替换为想要的图标编码 */
}

/* 或者完全替换为自定义样式 */
/deep/ .el-table__expand-icon {
  position: relative;
}

/deep/ .el-table__expand-icon .el-icon-arrow-right {
  display: none;
}

/deep/ .el-table__expand-icon:before {
  content: "▶"; /* 自定义字符图标 */
  font-size: 18px;
  color: #409eff;
}

/deep/ .el-table__expand-icon--expanded:before {
  transform: rotate(90deg);
}
.booth{
  background-color: #FAECD8;
  border: 1px dashed #E6A23C;
  padding: 8px 24px;
  border-radius: 8px;
}
.booth-title{
  color: #251716;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  span{
    font-size: 12px;
    font-weight: 400;
    margin-left: 10px;
  }
}
.booth-members{
  display: flex;
  margin-top: 10px;
}
.booth-member{
  margin-right: 50px;
}
.booth-avatar{
  width: 44px;
  height: 44px;
  border-radius: 44px;
  border: 2px solid #E6A23C;
}
.booth-role{
  font-size: 12px;
  font-weight: bold;
  color: #E6A23C;
  text-align: center;
  margin-bottom: 10px;
}
.booth-name{
  text-align: center;
  color: #000;
  font-size: 14px;
  font-weight: bold;
}
/deep/ .image-slot{
  width: 100%;
  height: 100%;
  background-color: #FDF6EC;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  color: #E6A23C;
}
</style>
